import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { calculateTextSpaces } from '../utils/calculateTextSpaces';
import * as styles from './AllSpaceText.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var AllSpaceText = function AllSpaceText(_ref) {
  var text = _ref.text,
    height = _ref.height,
    heightPercent = _ref.heightPercent,
    onAllSpaceCalculated = _ref.onAllSpaceCalculated;
  var containerRef = React.useRef(null);
  var textRef = React.useRef(null);
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    letterSpacing = _React$useState2[0],
    setLetterSpacing = _React$useState2[1]; // начальное расстояние между буквами
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    wordSpacing = _React$useState4[0],
    setWordSpacing = _React$useState4[1]; // начальное расстояние между словами

  var adjustText = React.useCallback(function (containerEl, textEl) {
    var textSpaces = calculateTextSpaces(containerEl, textEl);
    setLetterSpacing(textSpaces.letterSpacing);
    setWordSpacing(textSpaces.wordSpacing);
    return textSpaces;
  }, []);
  var adjustTextDebounced = React.useMemo(function () {
    return debounce(500, adjustText);
  }, [adjustText]);
  React.useEffect(function () {
    if (!containerRef.current || !textRef.current) {
      return;
    }
    var containerEl = containerRef.current;
    var textEl = textRef.current;
    var textSpaces = adjustText(containerEl, textEl);

    // Если функция вернула true, то не нужно делать лишние действия
    if (onAllSpaceCalculated !== null && onAllSpaceCalculated !== void 0 && onAllSpaceCalculated(textSpaces)) {
      return;
    }
    var observer = new ResizeObserver(function () {
      return adjustTextDebounced(containerEl, textEl);
    });
    observer.observe(containerEl);
    return function () {
      return observer.disconnect();
    };
  }, [text]);
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    className: styles['container'],
    children: /*#__PURE__*/_jsx("span", {
      ref: textRef,
      className: styles['text'],
      style: {
        fontSize: "calc(".concat(height, " * ").concat(heightPercent / 100, ")"),
        letterSpacing: letterSpacing,
        wordSpacing: wordSpacing
      },
      children: text
    })
  });
};